var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNetsuite = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26758 16.3488H13.8537V41.168H19.1245V50.8665H3.26758V16.3488ZM52.2676 39.1843H41.6814V14.365H36.4107V4.6665H52.2676V39.1843Z",
    fill: "#B5C8D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40039 2.3335H34.151V30.8619L21.558 14.4015H1.40039V2.3335ZM54.1337 53.6668H21.3831V25.1385L33.9761 41.5988H54.1337",
    fill: "#004482"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNetsuite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/netsuite.e2be6f46d91f6d6774ed855d67ec202d.svg";